import { createFileRoute } from '@tanstack/react-router';

import { AccessDenied } from '~/components/common/access-denied/access-denied';

/**
 * Static fallback page used by `requireFeatureGate` and any other guard that
 * needs to abort navigation with a user-facing reason. Lives under `_tenant`
 * so the standard sidebar / shell render around it.
 */
export const Route = createFileRoute('/_authenticated/_tenant/access-denied')({
  component: AccessDenied,
});
